module.exports = __webpack_public_path__ + "img/39.cc40b327.svg";